export default __webpack_public_path__ + "static/media/female_fat_percent.a5e5ab05.png";